document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  function hideElement(element) {
    if (element) {
      element.style.display = 'none';
    }
  }

  function showElement(element) {
    if (element) {
      element.style.display = '';
    }
  }

  function toggleElement(element) {
    if (!element) return;

    const currentDisplay = window.getComputedStyle(element).display;

    if (currentDisplay === 'none') {
      element.style.display = '';
    } else {
      element.style.display = 'none';
    }
  }

  function getSiblings(element) {
    if (!element || !element.parentElement) return [];

    return Array.prototype.filter.call(element.parentElement.children, function (child) {
      return child !== element;
    });
  }

  function getNextElement(element) {
    return element ? element.nextElementSibling : null;
  }

  // Tooltip
  document.querySelectorAll('.wn-pulse-dot').forEach(function (dot) {
    dot.addEventListener('click', function () {
      const parent = dot.parentElement;

      if (!parent) return;

      parent.classList.toggle('open');

      getSiblings(parent).forEach(function (sibling) {
        sibling.classList.remove('open');
      });
    });
  });

  document.querySelectorAll('.wn-close-tooltip').forEach(function (button) {
    button.addEventListener('click', function () {
      document.querySelectorAll('.wn-pulse-dot').forEach(function (dot) {
        if (dot.parentElement) {
          dot.parentElement.classList.remove('open');
        }
      });
    });
  });

  // Accordion initial state
  document.querySelectorAll('#wn-accordion .wn-accordion-block .wn-accordion-content').forEach(function (content) {
    hideElement(content);
  });

  // Add classes/data to accordion titles
  document.querySelectorAll('#wn-accordion .wn-accodrion-title').forEach(function (title, index) {
    const key = 'wn-acc' + index;

    title.classList.add(key);
    title.setAttribute('data-toggle', key);
  });

  // Add ids to dots
  document.querySelectorAll('#wn-accordionDots .wn-acc-dot').forEach(function (dot, index) {
    dot.id = 'wn-acc' + index;
  });

  // Accordion title click
  document.querySelectorAll('#wn-accordion .wn-accodrion-title').forEach(function (title) {
    title.addEventListener('click', function () {
      const targetKey = title.getAttribute('data-toggle');
      const content = getNextElement(title);

      document.querySelectorAll('#wn-accordion .wn-accodrion-title').forEach(function (otherTitle) {
        if (otherTitle !== title) {
          otherTitle.classList.remove('active');
          hideElement(getNextElement(otherTitle));
        }
      });

      document.querySelectorAll('#wn-accordionDots .wn-acc-dot').forEach(function (dot) {
        if (dot.id !== targetKey) {
          dot.classList.remove('open');
        }
      });

      title.classList.toggle('active');
      toggleElement(content);

      if (targetKey) {
        const matchingDot = document.getElementById(targetKey);

        if (matchingDot) {
          matchingDot.classList.toggle('open');
        }
      }
    });
  });

  // Accordion dot click
  document.querySelectorAll('#wn-accordionDots .wn-acc-dot').forEach(function (dot) {
    dot.addEventListener('click', function () {
      const dotId = dot.id;
      const matchingTitle = document.querySelector('#wn-accordion .wn-accodrion-title.' + CSS.escape(dotId));

      document.querySelectorAll('#wn-accordionDots .wn-acc-dot').forEach(function (otherDot) {
        if (otherDot !== dot) {
          otherDot.classList.remove('open');
        }
      });

      document.querySelectorAll('#wn-accordion .wn-accodrion-title').forEach(function (title) {
        if (title !== matchingTitle) {
          title.classList.remove('active');
          hideElement(getNextElement(title));
        }
      });

      dot.classList.toggle('open');

      if (matchingTitle) {
        matchingTitle.classList.toggle('active');
        toggleElement(getNextElement(matchingTitle));
      }
    });
  });

  // Popup IDs on pulse dots
  document.querySelectorAll('.wn-pop-image-block .wn-pulse-dot').forEach(function (dot, index) {
    dot.id = 'wn-pop-open' + index;
  });

  // Popup open classes
  document.querySelectorAll('.wn-open-popup').forEach(function (popup, index) {
    const key = 'wn-pop-open' + index;

    popup.classList.add(key);
    popup.setAttribute('data-label', key);
  });

  function openPopupByKey(key) {
    if (!key) return;

    document.querySelectorAll('.' + CSS.escape(key)).forEach(function (popup) {
      popup.classList.add('open');
    });
  }

  document.querySelectorAll('.wn-pop-image-block .wn-pulse-dot').forEach(function (dot) {
    dot.addEventListener('click', function () {
      openPopupByKey(dot.id);
    });
  });

  document.querySelectorAll('.wn-open-popup').forEach(function (popup) {
    popup.addEventListener('click', function () {
      openPopupByKey(popup.getAttribute('data-label'));
    });
  });

  document.querySelectorAll('.wn-popup-close').forEach(function (button) {
    button.addEventListener('click', function () {
      const popup = button.closest('.open');

      if (popup) {
        popup.classList.remove('open');
      }
    });
  });

  document.querySelectorAll('.wn-popup-backdrop').forEach(function (backdrop) {
    backdrop.addEventListener('click', function () {
      if (backdrop.parentElement) {
        backdrop.parentElement.classList.remove('open');
      }
    });
  });

  // Product tabs
  const tabs = document.querySelectorAll('.pro-tabs-stage .pro-tab-main');

  tabs.forEach(function (tab) {
    hideElement(tab);
  });

  if (tabs[0]) {
    showElement(tabs[0]);
  }

  document.querySelectorAll('.pro-tabs-nav a').forEach(function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault();

      document.querySelectorAll('.pro-tabs-nav li').forEach(function (item) {
        item.classList.remove('pro-tabs-active');
      });

      if (link.parentElement) {
        link.parentElement.classList.add('pro-tabs-active');
      }

      tabs.forEach(function (tab) {
        hideElement(tab);
      });

      const targetSelector = link.getAttribute('href');

      if (targetSelector) {
        const targetTab = document.querySelector(targetSelector);

        if (targetTab) {
          showElement(targetTab);
        }
      }
    });
  });
});